import API, { baseURL } from './api';
import { getSucursalInfo } from './auth';

// Client for sge_infantil_core's routes/subject.js (mounted at /api/subjects).
// Backend only exposes create + list — there is no update/delete endpoint
// (the old sge_infantil_web subject/edit page was dead/broken code that hit
// student endpoints by mistake), so this module intentionally has no edit UI.
export async function createSubject(payload) {
  const sucursalId = getSucursalInfo()?.id || 1;
  return API.post(`${baseURL}api/subjects`, {
    sucursalId,
    isCurricular: false,
    ...payload,
  });
}

export async function listAllSubjects(sucursalId) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.get(`${baseURL}api/subjects/all/${id}`);
}
